<template>
  <div class="rounded-md grid grid-cols-list-sm lg:grid-cols-list gap-x-3">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'm-grid-list',
};
</script>

<style>

</style>
